function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_142",
  "data-name": "Group 142",
  transform: "translate(-647 -5247)"
}, React.createElement("path", {
  id: "Path_34",
  "data-name": "Path 34",
  d: "M256.743,121.033a12.407,12.407,0,0,0-9.573-9.829,6.623,6.623,0,0,0-1.367-.231,11.1,11.1,0,0,0-1.866-.019,5.922,5.922,0,0,0-1.055.15,11.9,11.9,0,0,0-9.049,6.727,10.272,10.272,0,0,0-.537,8.543,33.914,33.914,0,0,0,3.17,6.1,86.954,86.954,0,0,0,6.933,9.3c.437.524.886,1.036,1.354,1.579.125-.137.225-.243.318-.349a96.718,96.718,0,0,0,6.06-7.67,46.4,46.4,0,0,0,4.618-7.763A10.943,10.943,0,0,0,256.743,121.033Zm-11.994,7.751a6.792,6.792,0,0,1-6.783-6.446c-.006-.112-.006-.225-.006-.343s0-.231.006-.349a6.792,6.792,0,0,1,13.567,0c.006.119.012.231.012.349s-.006.231-.012.343A6.788,6.788,0,0,1,244.749,128.784Z",
  transform: "translate(421.362 5138.288)",
  fill: "#2c3e50"
}), React.createElement("rect", {
  id: "Rectangle_31",
  "data-name": "Rectangle 31",
  width: 37,
  height: 37,
  transform: "translate(647 5247)",
  fill: "none",
  opacity: 0.37
}));

var SvgLocation = function SvgLocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location.7ec8dd15.svg";
export { ForwardRef as ReactComponent };